import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ExclamationCircleFilled } from "@ant-design/icons";
import {
  Badge,
  Button,
  Col,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import COLORS from "common/Colors";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { EyeOutlined } from "@ant-design/icons";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { uniqBy } from "lodash";
import { connect, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getLocations,
  getMenuList,
  getRoleList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import RolesAndPermissions from "./RolesAndPermissions";
import { bindActionCreators } from "redux";
import {
  setMenuList,
  setRoleList,
  setUserList,
  setUserRole,
} from "redux/actions";
import SuccessPopup from "./SuccessPopup";

const DetailsWrapp = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .ant-select-item {
    text-align: start;
  }
  .change-view {
    color: #2d53da;
    border-radius: 10px;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view: hover {
    background: #c5cff5;
  }
`;

const StyledTable = styled(Table)`
  table {
    table-layout: auto !important;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  &.table-has-selection .ant-table-content {
    height: calc(100vh - 300px);
  }

  &.table-no-selection .ant-table-content {
    height: calc(100vh - 210px);
  }
  .ant-table-cell {
    padding: 10px;
    height: 50px !important;
    border: none;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    background: none;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  .non-white {
    background: #f9f9f9;
  }
  .action-content {
    display: none;
  }

  .action-icons {
    display: none;
  }

  /* Show only when row is hovered */
  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 8px;
  }
`;

const sampledata = [
  {
    fullname: "John Doe",
    employeeid: "EMP001",
    basedepartmentid: "HR",
    baselocationid: "New York",
  },
];

const RoleDetails = ({
  details,
  setIsViewDetails,
  saveRoleList,
  updateUserList,
  saveMenuList,
  saveUserRole,
}) => {
  const { Option } = Select;
  const AllDepartmentList = useSelector(getAllDepartmentList);
  const userInfo = useSelector(getUserInfo);
  const locationList = useSelector(getLocations);
  const userList = useSelector(getUserList);
  const roleList = useSelector(getRoleList);
  const clientId = useSelector(getClientid);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  console.log("userInfo-->", userInfo);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const [isCustomPermission, setIsCustomPermission] = useState(false);

  const filteredUserBasedonRole = userList?.filter((item) => {
    if (isCustomPermission) {
      return (
        item?.roleid?.includes(details?.roleId) &&
        item?.permissiontype === "Custom" &&
        item?.statusid === "1"
      );
    } else {
      return item?.roleid?.includes(details?.roleId) && item?.statusid === "1";
    }
  });

  console.log("filteredUserBasedonRole", filteredUserBasedonRole);
  const [form] = Form.useForm();
  const [changeRoleForm] = Form?.useForm();
  const [typeForm] = Form?.useForm();
  const containerRef = React.useRef(null);
  const [isChangeRole, setIsChangeRole] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  console.log("userDetails-->", userDetails);
  console.log("userdetails-->", userDetails);

  const [filteredList, setFilteredList] = useState(filteredUserBasedonRole);
  const [loading, setLoading] = useState(false);

  const [isBulkChange, setIsBulkChange] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const fetchMasterData = async (fetch_master_data) => {
    setLoading(true);
    const { code, roleList, userList, menuList, role_id, userrole } =
      await CALL_API(`master-data/${clientId}`, "post", {
        fetch_master_data,
      });
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        console.log(
          "roleList-->",
          userList?.find((user) => user?.userid === userInfo?.userid)?.menulist
        );
        saveUserRole(role_id[0]);
        if (userrole === "Owner") {
          saveMenuList(menuList);
        } else {
          saveMenuList(
            userList?.find((user) => user?.userid === userInfo?.userid)
              ?.menulist
          );
        }
        saveRoleList(roleList);
        updateUserList(userList);
      }
    }
    setLoading(false);
  };

  const showCustomizeWarning = (menuList) => {
    Modal.confirm({
      icon: null, // remove default AntD icon
      title: null, // remove default title
      centered: true,
      maskClosable: false,
      keyboard: false,
      width: 520,
      content: (
        <div style={{ textAlign: "center", padding: "8px 12px" }}>
          <ExclamationCircleFilled
            style={{
              fontSize: 44,
              color: "#ff4d4f",
              marginBottom: 16,
              display: "inline-block",
            }}
          />
          <div style={{ fontSize: 14, color: "#333", lineHeight: 1.6 }}>
            You are customizing permissions specifically for this employee. This
            will override the default role-based permissions.
            <br />
            <br />
            Do you want to continue with the changes?
          </div>
        </div>
      ),
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        style: {
          borderRadius: 6,
          padding: "6px 20px",
          background: "#2D53DA",
          borderColor: "#2D53DA",
        },
      },
      cancelButtonProps: {
        style: {
          borderRadius: 6,
          padding: "6px 20px",
          background: "transparent",
          color: "#2D53DA",
          border: "1px solid #2D53DA",
        },
      },
      onOk: async () => {
        updateChangeRole(userDetails, "Custom", menuList);
      },
      // onCancel: () => {
      //   setIsEdit(false);
      // },
    });
  };

  const updateChangeRole = async (record, type, menuList) => {
    setLoading(true);
    const { code, response } = await CALL_API(
      `add-users/change-role`,
      "patch",
      {
        userids: record === true ? selectedRowKeys : [record?.userid],
        roleid: isEdit
          ? userDetails?.roleid[0]
          : type === "Default"
          ? details?.roleId
          : changeRoleForm?.getFieldValue("roleid"),
        permissiontype: type || typeForm?.getFieldValue("permissiontype"),
        custommenulist: menuList || [],
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      await fetchMasterData(true);
      setSuccessModal(true);
      setSuccessMessage(
        isEdit
          ? "Changes Saved!"
          : isCustomPermission
          ? "Done!"
          : isBulkChange
          ? "Role Changed!"
          : "Role Changed!"
      );
      setTimeout(() => {
        setSuccessModal(false);
        setSuccessMessage("");
      }, 3000);

      setLoading(false);
      setSelectedRowKeys([]);
      setIsEdit(false);
      setIsCustomPermission(false);
      setIsBulkChange(false);
      form?.resetFields();
      changeRoleForm?.resetFields();
      typeForm?.resetFields();
    } else {
      message?.error("Something went wrong");
      setLoading(false);
      setSelectedRowKeys([]);
      setIsEdit(false);
      setIsCustomPermission(false);
      setIsBulkChange(false);
      form?.resetFields();
      changeRoleForm?.resetFields();
      typeForm?.resetFields();
    }
  };

  const showRevertConfirm = () => {
    Modal.confirm({
      title: `Are you sure you want to revert the permissions to the default permission setup of the role "${details?.roleName}"?`,
      icon: null,

      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        loading: loading,
      },
      onOk: async () => {
        updateChangeRole(true, "Default");
      },
    });
  };

  const setDefault = (record) => {
    Modal.confirm({
      title: "Permission Preference",
      icon: null,
      content: (
        <Form
          form={typeForm}
          name="applyall"
          layout="vertical"
          initialValues={{ permissiontype: "Default" }}
        >
          <Form.Item
            className="pb-0 mb-0"
            label=""
            name="permissiontype"
            rules={[
              {
                required: false,
                message: "Please Select",
              },
            ]}
          >
            <Radio.Group
              placeholder="Radio.Group"
              getPopupContainer={() => containerRef.current}
            >
              <Radio value="Custom">
                Retain the employee's current permissions
              </Radio>
              <Radio value="Default">
                Apply the default permissions of the new role
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      ),
      okText: "Complete",
      cancelText: "Cancel",
      okButtonProps: {
        loading: loading,
      },
      onOk: async () => {
        updateChangeRole(record);
      },
    });
  };

  // const showChangeConfirm = (record) => {
  //   changeRoleForm.resetFields();

  //   Modal.confirm({
  //     title: "Changing Role",
  //     icon: null,
  //     content: (
  //       <Form
  //         form={changeRoleForm}
  //         name="changeRoleForm"
  //         layout="vertical"
  //         initialValues={{ roleid: "" }}
  //       >
  //         <Form.Item className="pb-0 mb-0" label="Choose Role" name="roleid">
  //           <Select
  //             placeholder="Select"
  //             options={roleList}
  //             fieldNames={{
  //               label: "roleName",
  //               value: "roleId",
  //             }}
  //             getPopupContainer={() => containerRef.current}
  //           />
  //         </Form.Item>
  //       </Form>
  //     ),
  //     okText: "Next",
  //     cancelText: "Cancel",
  //     okButtonProps: {
  //       loading: loading,
  //     },
  //     onOk: async () => {
  //       const roleid = changeRoleForm.getFieldValue("roleid");

  //       if (roleid) {
  //         console.log("working");
  //         setIsChangeRole(true);
  //         setDefault(record);
  //         return Promise.resolve();
  //       }

  //       return Promise.reject(false);
  //     },
  //   });
  // };

  const showChangeConfirm = (record, roleid) => {
    changeRoleForm.setFieldsValue({ roleid }); // <-- Set the value here

    Modal.confirm({
      title: "Changing Role",
      icon: null,
      content: (
        <Form form={changeRoleForm} name="changeRoleForm" layout="vertical">
          <Form.Item
            className="pb-0 mb-0"
            label="Choose Role"
            name="roleid"
            rules={[
              {
                required: true,
                message: "Role is required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              options={roleList}
              fieldNames={{ label: "roleName", value: "roleId" }}
              getPopupContainer={() => containerRef.current}
            />
          </Form.Item>
        </Form>
      ),
      okText: "Next",
      cancelText: "Cancel",
      okButtonProps: { loading },
      onCancel: async () => {
        console.log("Cancelled");
        await changeRoleForm.resetFields();
      },
      onOk: async () => {
        console.log("working");
        setIsChangeRole(true);
        setDefault(record);
        return Promise.resolve();
      },
    });
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    const peopleSelect = values?.name || [];
    const depSelected = values.department || [];
    const locSelected = values.location || [];
    const typeSelect = values.type || [];

    // If both filters are empty, show the full list
    if (
      (!depSelected || depSelected.length === 0) &&
      (!locSelected || locSelected.length === 0) &&
      (!peopleSelect || peopleSelect.length === 0) &&
      (!typeSelect || typeSelect.length === 0)
    ) {
      setFilteredList(filteredUserBasedonRole);
      return;
    }

    const normalize = (val) => {
      if (val == null) return [];
      if (Array.isArray(val)) return val.map(String);
      if (typeof val === "object") {
        // handle cases like { "10": ["2"] } or nested objects -> flatten values
        return Object.values(val).flat().map(String).filter(Boolean);
      }
      return [String(val)];
    };

    const roleFilter = (filteredUserBasedonRole || []).filter((user) => {
      const userDepts = normalize(user?.basedepartmentid);
      const userLocs = normalize(user?.baselocationid);
      const users = normalize(user?.userid);
      const types = normalize(user?.permissiontype);

      const peopleMatch =
        !peopleSelect.length ||
        peopleSelect.some((sel) => users?.includes(String(sel)));

      const departmentMatch =
        !depSelected.length ||
        depSelected.some((sel) => userDepts.includes(String(sel)));

      const locationMatch =
        !locSelected.length ||
        locSelected.some((sel) => userLocs.includes(String(sel)));

      const typeMatch =
        !typeSelect.length ||
        typeSelect.some((sel) => types?.includes(String(sel)));

      return peopleMatch && departmentMatch && locationMatch && typeMatch;
    });

    setFilteredList(roleFilter);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      render: (text, record) => {
        return (
          <div className="d-flex gap-2">
            {record?.permissiontype === "Custom" && !isCustomPermission && (
              <Badge key={"red"} color={"red"} />
            )}
            <>{text}</>
          </div>
        );
      },
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
    },
    {
      title: "Department",
      dataIndex: "basedepartmentid",
      key: "basedepartmentid",
      render: (text) => {
        return AllDepartmentList?.find((val) => val?.department_id === text)
          ?.department_name;
      },
    },
    {
      title: "Location",
      dataIndex: "baselocationid",
      key: "baselocationid",
      render: (text, record) => {
        return locationList?.find((val) => val?.location_id === text)
          ?.location_name;
      },
    },
    !isCustomPermission &&
    !isBulkChange &&
    Menulist?.find(
      (item) =>
        item?.key === "manage" &&
        item?.subMenu.find(
          (subItem) => subItem?.key === "roles" && subItem?.permission.edit
        )
    )
      ? {
          title: "Actions",
          key: "actions",
          align: "center",
          width: "25%",
          render: (_, record) => (
            <>
              <div className="action-icons">
                <span
                  style={{
                    marginRight: 8,
                    cursor: "pointer",
                    color: "#2D53DA",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    showChangeConfirm(record, record?.roleid?.[0]);
                  }}
                >
                  <AutorenewIcon
                    style={{
                      cursor: "pointer",
                      color: "#2D53DA",
                      fontSize: "18px",
                    }}
                  />{" "}
                  Change Role
                </span>
                <Edit
                  style={{ cursor: "pointer", marginRight: "10px" }}
                  corlor="red"
                  onClick={(e) => {
                    e.stopPropagation();
                    setUserDetails(record);
                    setIsEdit(true);
                  }}
                />
              </div>
            </>
          ),
        }
      : {},
    isBulkChange ? Table.SELECTION_COLUMN : {},
  ];

  const uniqueName = uniqBy(
    filteredUserBasedonRole?.map((item) => {
      return {
        label: item?.fullname,
        value: item?.userid,
      };
    }),
    "value"
  );

  const uniqueDepartmentName = uniqBy(
    AllDepartmentList?.map((item) => {
      return {
        label: item?.department_name,
        value: item?.department_id,
      };
    }),
    "value"
  );

  const uniqueLocationName = uniqBy(
    locationList
      ?.filter((val) => val?.login_from_anywhere !== 1)
      .map((item) => {
        return {
          label: item?.location_name,
          value: item?.location_id,
        };
      }),
    "value"
  );

  useEffect(() => {
    setFilteredList(filteredUserBasedonRole);
  }, [isCustomPermission, roleList, userList]);

  const footerStyle = {
    position: "absolute",
    bottom: -40,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };
  return (
    <DetailsWrapp>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <label
            className="bg-transparent border-0 mb-3 text-left styled-cursor"
            onClick={() => setIsViewDetails(false)}
          >
            Role - Permission <ArrowForwardIosIcon className="px-1" />
          </label>{" "}
          {(isCustomPermission || isView || isEdit) && (
            <label
              className="bg-transparent border-0 mb-3 text-left styled-cursor"
              onClick={() => {
                isEdit
                  ? setIsEdit(false)
                  : isView
                  ? setIsView(false)
                  : setIsCustomPermission(false);
              }}
            >
              {details?.roleName} <ArrowForwardIosIcon className="px-1" />
            </label>
          )}
          {isEdit && (
            <label
              className="bg-transparent border-0 mb-3 text-left styled-cursor"
              onClick={() => {
                setIsEdit(false);
              }}
            >
              {userDetails?.fullname} <ArrowForwardIosIcon className="px-1" />
            </label>
          )}
          <b className="pb-0 pt-1">
            {isCustomPermission
              ? "Custom Permission"
              : isView
              ? userDetails?.fullname
              : isEdit
              ? "Editing Permission"
              : details?.roleName}
          </b>
        </div>
        {!isCustomPermission && !isView && !isEdit && !isBulkChange && (
          <Button
            type="link"
            className="change-view"
            onClick={() => {
              setIsBulkChange(false);
              setIsCustomPermission(true);
            }}
          >
            Custom Permission
          </Button>
        )}
      </div>
      {!isView && !isEdit && (
        <>
          <Form
            form={form}
            layout="vertical"
            className="mt-2"
            onValuesChange={handleFormChange}
          >
            <Row gutter={12} className="g-3">
              <Col
                xs={24}
                sm={24}
                md={8}
                lg={8}
                xl={isCustomPermission ? 12 : 4}
              >
                <label className="mt-2">
                  {isBulkChange && selectedRowKeys?.length > 0
                    ? `Selected People: ${selectedRowKeys?.length}`
                    : `Total Employees: ${filteredList?.length}`}
                </label>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={4} ref={containerRef}>
                <DropdownCheckBox
                  name="name"
                  label="People"
                  options={uniqueName}
                  form={form}
                  handleFormChange={handleFormChange}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={4} ref={containerRef}>
                <DropdownCheckBox
                  name="department"
                  label="Department"
                  options={uniqueDepartmentName}
                  form={form}
                  handleFormChange={handleFormChange}
                />
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={4} ref={containerRef}>
                <DropdownCheckBox
                  name="location"
                  label="Location"
                  options={uniqueLocationName}
                  form={form}
                  handleFormChange={handleFormChange}
                />
              </Col>
              {!isCustomPermission && (
                <>
                  <Col xs={24} sm={24} md={8} lg={8} xl={4} ref={containerRef}>
                    <DropdownCheckBox
                      name="type"
                      label="Permission Type"
                      options={uniqBy(
                        ["Custom", "Default"]?.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                        "value"
                      )}
                      form={form}
                      handleFormChange={handleFormChange}
                    />
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={8}
                    lg={8}
                    xl={4}
                    ref={containerRef}
                    className="w-100 text-end"
                  >
                    <Button
                      type="link"
                      className="w- 100 change-view"
                      disabled={
                        !Menulist?.find(
                          (item) =>
                            item?.key === "manage" &&
                            item?.subMenu.find(
                              (subItem) =>
                                subItem?.key === "roles" &&
                                subItem?.permission.edit
                            )
                        ) || isBulkChange
                      }
                      onClick={() => {
                        setIsCustomPermission(false);
                        setIsBulkChange(true);
                      }}
                    >
                      Bulk Role Change
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </Form>
          <Spin spinning={loading}>
            <StyledTable
              className={`mt-0 ${
                selectedRowKeys?.length > 0
                  ? "table-has-selection"
                  : "table-no-selection"
              }`}
              dataSource={filteredList || []}
              columns={columns}
              rowKey="userid"
              pagination={false}
              onRow={(record) => ({
                onClick: (e) => {
                  e.stopPropagation();
                  setUserDetails(record);
                  setIsView(true);
                },
                className: "hover-row",
              })}
              rowSelection={
                (isBulkChange || isCustomPermission) &&
                Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "roles" && subItem?.permission.edit
                    )
                )
                  ? rowSelection
                  : undefined
              }
            />
          </Spin>
          {selectedRowKeys?.length > 0 && (
            <div style={footerStyle}>
              <ButtonOutlined
                onClick={() => {
                  setIsCustomPermission(false);
                  setIsBulkChange(false);
                  setSelectedRowKeys([]);
                }}
              >
                Cancel
              </ButtonOutlined>
              <ButtonFilled
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={() =>
                  isCustomPermission
                    ? showRevertConfirm(true, "Default")
                    : showChangeConfirm(true, roleList[0]?.roleId)
                }
              >
                {isCustomPermission ? "Revert to Default Permission" : "Next"}
              </ButtonFilled>
            </div>
          )}
        </>
      )}
      {(isView || isEdit) && (
        <>
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <div>Permission</div>
            {isView && (
              <Button
                type="link"
                style={{ color: "#2D53DA" }}
                onClick={() => {
                  setIsView(false);
                  setIsEdit(true);
                }}
              >
                <Edit
                  style={{ cursor: "pointer", marginRight: "10px" }}
                  corlor="red"
                />{" "}
                Edit Permission
              </Button>
            )}
          </div>
          <RolesAndPermissions
            menuList={
              userDetails?.menulist?.[String(userDetails?.roleid ?? "")] ?? []
            }
            setsubmit={() => {}}
            onFinish={showCustomizeWarning}
            loading={loading}
            type={isEdit ? "edit" : "view"}
            viewOnly={isEdit ? false : true}
            handleCancel={setIsEdit}
          />
        </>
      )}
      <SuccessPopup
        open={successModal}
        close={setSuccessModal}
        text={successMessage}
      />
    </DetailsWrapp>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
      saveRoleList: setRoleList,
      saveMenuList: setMenuList,
      saveUserRole: setUserRole,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps, null)(RoleDetails);
